import { useAuth } from "react-oidc-context";
import AuthStatus from "./auth-status";

const PrivateRoute = ({ children, rolesAllowed }) => {
    const auth = useAuth();

    switch (auth.activeNavigator) {
        case 'signinSilent':
          return <AuthStatus title="Login" text="Efetuando login..."/>;
        case 'signoutRedirect':
          return <AuthStatus title="Logout" text="Efetuando logout..."/>;
        default:
          break;            
    }
    
    if (auth.isLoading) {
        return <AuthStatus title="Login" text="Carregando..."/>;
    }

    if (auth.error) {
        if (auth.error.message.includes('Failed to fetch')) {
            auth.removeUser();
            auth.signoutRedirect({
                post_logout_redirect_uri: process.env.REACT_APP_URL_TCECOMUNICA
            });
        } else {
            return <AuthStatus title="Login" text={`Ops... Ocorreu um erro ao autenticar: ${auth.error.message}`}/>;
        }
    }

    let originPath = window.location.pathname;
    if (!auth.isAuthenticated) {
        auth.signinRedirect({
          redirect_uri: process.env.REACT_APP_URL_TCECOMUNICA.concat(originPath),
        });
    }

    if (auth.isAuthenticated) {
        window.history.replaceState({}, document.title, originPath);
        if (!rolesAllowed) return <AuthStatus title="Perfil não definido." text="Não foi definido nenhum perfil para acesso a esta página (rolesAllowed nulo)."/>
        const isAuthorized = rolesAllowed.some(role => { return auth.user?.profile.role.includes(role); });
        return isAuthorized ? children : <AuthStatus title="Acesso não autorizado." text="Solicite ao seu gestor a concessão do perfil de acesso necessário para esta ação."/>;
    }

    return null;
}

export default PrivateRoute;